
// import Notice from "~/components/home/notice.vue";
import BannerTop from "@/components/home/bannerTop.vue";
import CommonTitle from "@/components/home/commonTitle.vue";
export default {
  name:"technology",
  components: {
    CommonTitle,
    BannerTop,
    // Notice
  },
  data() {
    return {
      bannerUrl:require("@/static/images/coreTechnology/banner.png"),
      list:[
        [
          {
            imgUrl:require(`@/static/images/coreTechnology/1.png`),
            name:this.$t('nav.Smartcontract'),
            path:"/technology/arcturus"
          },
          {
            imgUrl:require(`@/static/images/coreTechnology/2.png`),
            name:this.$t('nav.Privacycomputing'),
            path:"/technology/sirius"
          }
        ],
        [
          {
            imgUrl:require(`@/static/images/coreTechnology/4.png`),
            name:this.$t('nav.Bigdata'),
            path:"/technology/canopus"
          },
          {
            imgUrl:require(`@/static/images/coreTechnology/3.png`),
            name:this.$t('nav.blockchain'),
            path:"/technology/procyon"
          }
        ],
        [
          {
            imgUrl:require(`@/static/images/coreTechnology/5.png`),
            name:this.$t('nav.Artificialintelligence'),
            path:"/technology/rigel"
          },
          {
            imgUrl:require(`@/static/images/coreTechnology/6.png`),
            name:this.$t('nav.Cloudcomputing'),
            path:"/technology/cloud"
          }
        ]
      ]
    }
  },
}
